module.exports = __webpack_public_path__ + "img/hzhb.3d5363a8.jpg";